import { styled } from '@linaria/react';

export const Theme = styled.div`
  all: initial;
  border-radius: var(--widget-border-radius);
  box-sizing: border-box;
  display: block;
  font-family: var(--font-family);
  font-size: var(--base-font-size);
  line-height: var(--base-line-height);
  position: relative;
  z-index: var(--cxy-z-index-internal-base);
  width: 100%;
  container-name: base;
  container-type: inline-size;

  * {
    box-sizing: inherit;
    font-family: inherit;
  }

  :focus-visible {
    outline: 2px solid var(--outline-color);
  }
  /* Generic variables */
  --font-family: urw-din, Trebuchet MS, serif;
  --base-font-size: 1rem;
  --base-line-height: 1.5;
  --widget-border-radius: 8px;

  /* Generic colors */
  --primary-color: #00e889;
  --anchor-color: var(--primary-color);
  --outline-color: var(--primary-color);

  /* Offer */
  --offer-border-radius: 0.5rem;
  --offer-bookmaker-logo-width: 95px;
  --offer-bookmaker-logo-height: 25px;
  --offer-cta-border-radius: 0.25rem;
  --offer-cta-padding: 0.5rem 0rem;
  --offer-cta-color: #000000;
  --offer-cta-bg-color: var(--primary-color);
  /* UK site doesn't change on hover */
  --offer-cta-bg-color-hover: #167c52;
`;
